import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { AppProviders } from './providers';
import { AppErrorBoundary } from './errors/ErrorBoundary';

export const App: React.FC = () => (
  <AppErrorBoundary>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </AppErrorBoundary>
);
